"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var makeMediaQuery = function makeMediaQuery(size, type, styles) {
  return "\n  @media (" + type + "-width: " + (size - (type === "max" ? 1 : 0)) + "px) {\n    " + styles + "\n  }\n";
};

var _default = makeMediaQuery;
exports["default"] = _default;